import React, { useMemo } from "react";
import { getStorageValues } from "../../../shared/CommonFunctions";
import ReportViewer from "./components/ReportViewer";
import { generateStandardReportPdf } from "./utils/reportPdfGenerators";

const isCompletedStatus = (status) => {
  const s = String(status || "").trim().toLowerCase();
  return s === "complete" || s === "completed";
};

export default function RtoPendingReport() {
  const columns = useMemo(
    () => [
      { name: "Sales #", selector: (r) => r.SalesNumber || "-" },
      { name: "Customer", selector: (r) => r.CustomerName || "-" },
      { name: "Mobile", selector: (r) => r.MobileNumber || "-" },
      { name: "Vehicle Reg #", selector: (r) => r.VehicleRegistrationNumber || "-" },
      { name: "Status", selector: (r) => r.Status || "-" },
      { name: "Remark", selector: (r) => r.Remark || "-" },
    ],
    []
  );

  return (
    <ReportViewer
      reportKey="rtoPending"
      title="RTO Pending"
      columns={columns}
      fetchConfig={{
        url: "/rtoregister/getall",
        paramsBuilder: () => ({ UserId: getStorageValues("userId") }),
        transform: (data) => {
          const rows = Array.isArray(data) ? data : Array.isArray(data?.[0]) ? data[0] : [];
          return rows.filter((x) => !isCompletedStatus(x?.Status));
        },
      }}
      buildKpis={(rows) => [{ label: "Pending", value: rows?.length ?? 0 }]}
      pdfGenerator={generateStandardReportPdf}
    />
  );
}

